import { supabaseClient } from '@plataforma/supabase-client';

/**
 * @param {{ limite?: number }} [opciones]
 */
export async function listarPublicaciones(opciones = {}) {
  const { limite = 50 } = opciones;
  return supabaseClient()
    .from('publicacion')
    .select(
      'id, empresa_id, estado, iniciado_en, finalizado_en, detalle_error, archivos_generados, duracion_ms, empresa (nombre)',
    )
    .order('iniciado_en', { ascending: false })
    .limit(limite);
}

/**
 * @param {string} empresaId
 */
export async function republicarTienda(empresaId) {
  const { data, error } = await supabaseClient().functions.invoke('publicar_tienda', {
    body: { empresa_id: empresaId },
  });

  if (error) {
    let mensaje = error.message;
    try {
      const cuerpo = await error.context?.json?.();
      if (cuerpo?.error) mensaje = cuerpo.error;
    } catch {
      // Se conserva el mensaje original de supabase-js.
    }
    return { data: null, error: { message: mensaje } };
  }

  return { data, error: null };
}
